module.exports = __webpack_public_path__ + "static/media/cookies_icon--active.b3d11cc6.svg";